// extracted by mini-css-extract-plugin
export default {"InfoTooltipInfo":"styles_InfoTooltipInfo__F2c7B","InfoTooltip":"styles_InfoTooltip__Z9+o2"};